import React from 'react';
import './index.scss';
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import {ApplicationState} from '../../store';
import {User, UserTypes} from '../../store/ducks/user/types';
import * as UserActions from '../../store/ducks/user/actions';
import {Param, ParamTypes} from '../../store/ducks/param/types';
import * as ParamActions from '../../store/ducks/param/actions';
import { Redirect, Link } from "react-router-dom";
import Header from '../Header';
import Footer from '../Footer';
import Api from '../../services/api';
import {Diversos} from '../../services/diversos';

import InputMask from 'react-input-mask'
import Row from 'react-bootstrap/Row'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import {Spinner} from 'react-bootstrap'

import logoPreta from '../../assets/Images/domakoski-preta.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
  

interface StateProps { 
  user: User;
  param: Param;
}

interface DispatchProps {
  doLogin(user: User): void;
  doLogout(): void;

  setParam(data: Param): void;
}

interface OwnProps {}

type Props = StateProps & DispatchProps & OwnProps;

  
class InfoEdit extends React.Component<Props> {

  api: any = null;
  state: any = null;

  constructor(props) {
    super(props);

    this.api = new Api();

    this.state = {
      redirect: null,

      isLoading: false,
      isLoadingCustomer: true,
      customer: null,
      customerHasError: false,
      customerHasErrorTitle: null,
      customerHasErrorMsg: null,
      customerHasSuccess: false,
      customerHasSuccessTitle: null,
      customerHasSuccessMsg: null,
    }
  }

  componentDidMount () {
    const self = this;

    if (( self.props.user ) && ( self.props.user.status !== false )) { 
      self.getCustomer();
    }
  }

  private async getCustomer () {
    const self = this;

   self.setState({isLoadingCustomer: true});

    try {
      const {data} = await self.api.get(`/customer/${self.props.user.codigo}`);

      if ( data.status == false ) {
        throw new Error('Cadastro de cliente não localizado.');
      } else {
        self.setState({customer: data.msg});
      }

    } catch (e) {
      console.error(e);

      self.setState({
        customer: null,
        customerHasError: true,
        customerHasErrorTitle: 'Cadastro não localizado',
        customerHasErrorMsg: e.message
      });

    } finally {
      self.setState({isLoadingCustomer: false});
    }
  }

  private async handleSubmit () {
    const self = this;
    let param: any = {};

      // ===================== Arrumar validação do submit ===================== // 
      // ===================== Erro: "relativeURL.replace is not a function" ===================== // 

      if (( !self.state.customer.nome ) || ( !self.state.customer.cpf ) || ( !self.state.customer.nascimento ) || ( !self.state.customer.celular )) {
        self.setMsg( 'error', "Formulário incompleto", "Necessário preencher todos os campos obrigatórios (*) do formulário para continuar.");
        return;
      }

      if ( !Diversos.validateCPF(self.state.customer.cpf) ) {
        self.setMsg( 'error', "CPF inválido", "Necessário informar um CPF válido para continuar.");
        return;
      }

      param.nome = self.state.customer.nome;
      param.cpf = self.state.customer.cpf;
      param.nascimento = self.state.customer.nascimento;
      param.sexo = self.state.customer.sexo;
      param.celular = self.state.customer.celular;
      param.telefone = self.state.customer.telefone;

    self.setState({ isLoading: true });

    try {
      const {data} = await self.api.put(param);

      if (!data.status) {
        throw new Error(data.msg);
      } else {
        self.setMsg( 'success', "Sucesso", `Cadastro atualizado com sucesso.`);
      }

    } catch (e) {
      console.error(e);
      self.setMsg( 'error', "Atenção", `Não foi possível atualizar cadastro. ${e.message}`);
    } finally {
      self.setState({ isLoading: false });
    }
  }

  /**
   * FUNCAO PARA SETAR ALERT DE ERROR OU SUCESSO COM TEMPORIZADOR
   * @param type 
   * @param title 
   * @param msg 
   */
  private async setMsg ( type: string, title: string, msg: string) {
    const self = this;
    let timeout = 5000;

    if ( type === "error" ) {
      
      self.setState({
        customerHasError: true,
        customerHasErrorTitle: title,
        customerHasErrorMsg: msg,
      }, () => {
        setTimeout(() => self.setState({ customerHasError: false }), timeout)
      });

    } else {

      self.setState({
        customerHasSuccess: true,
        customerHasSuccessTitle: title,
        customerHasSuccessMsg: msg,
      }, () => {
        setTimeout(() => self.setState({ customerHasSuccess: false }), timeout)
      });

    }
  }

  render () {
    return (
      <>
        {
          this.state.isLoadingCustomer === true ?
          <>
            <span className="py-3 w-100 m-auto text-center d-flex justify-content-center">
              <FontAwesomeIcon icon={faCircleNotch} spin={true} className="text-center m-auto spinner" style={{fontSize: 24}}/>
            </span>
          </>
          :
          <>

            {
              this.state.customerHasSuccess &&
              <div className="alert alert-success">
                <strong> {this.state.customerHasSuccessTitle} </strong>
                <br/>
                { this.state.customerHasSuccessMsg }
              </div>
            }

            {
              this.state.customerHasError &&
              <div className="alert alert-danger">
                <strong> {this.state.customerHasErrorTitle} </strong>
                <br/>
                {this.state.customerHasErrorMsg}
              </div>
            }

            <div className="data-input-wrapper">
              <Form.Row className="mx-auto">
                <Form.Group as={Col} controlId="formGridNome">
                  <Form.Label> Nome *</Form.Label>
                  <Form.Control type="text" placeholder="Nome" className="user-input input-border"
                  value={this.state.customer.nome} onChange={(event) => this.setState({customer: {...this.state.customer, nome: event.target.value}})} required/>
                </Form.Group>
              </Form.Row>
              <Form.Row className="mx-auto">
                <Form.Group as={Col} controlId="formGridCpf">
                  <Form.Label> CPF *</Form.Label>
                  <InputMask mask="999.999.999-99" value={this.state.customer.cpf} onChange={(event) => this.setState({customer: {...this.state.customer, cpf: event.target.value}})}>
                    {(inputProps) => <Form.Control {...inputProps} type="tel" placeholder="000.000.000-00" className="user-input input-border" required/>}
                  </InputMask>
                </Form.Group>
              </Form.Row>
              <Form.Row className="mx-auto">
                <Form.Group as={Col} controlId="formGridNascimento">
                  <Form.Label> Data de Nascimento * </Form.Label>
                  <InputMask mask="99/99/9999" value={this.state.customer.nascimento} onChange={(event) => this.setState({customer: {...this.state.customer, nascimento: event.target.value}})} required>
                    {(inputProps) => <Form.Control {...inputProps} type="tel" placeholder="99/99/9999" className="user-input input-border"/>}
                  </InputMask>
                </Form.Group>
              </Form.Row>
              <Form.Row className="mx-auto">
                <Form.Group as={Col} controlId="formGridTelefone">
                  <Form.Label> Celular * </Form.Label>
                  <InputMask mask="(99) 9 9999-9999" value={this.state.customer.celular} onChange={(event) => this.setState({customer: {...this.state.customer, celular: event.target.value}})}>
                    {(inputProps) => <Form.Control {...inputProps} type="tel" placeholder="(00) 00000-0000" className="user-input input-border" required/>}
                  </InputMask>
                </Form.Group>
                <Form.Group as={Col} controlId="formGridTelefone2" xs={12} sm={6}>
                  <Form.Label> Telefone 2 </Form.Label>
                  <InputMask mask="(99) 9 9999-9999" value={this.state.customer.telefone} onChange={(event) => this.setState({customer: {...this.state.customer, telefone: event.target.value}})}>
                    {(inputProps) => <Form.Control {...inputProps} type="tel" placeholder="(41) 9-9999-9999" className="user-input input-border"/>}
                  </InputMask>
                </Form.Group>
              </Form.Row>
            </div>

            <div className="data-actions">
              <a href="/meu-cadastro" className="btn-link-action"> Cancelar </a>
              <Button className="btn-secondary-action" type="submit" onClick={this.handleSubmit.bind(this)} disabled={this.state.isLoading}>
                { (this.state.isLoading) ? 'Salvando...' : 'Salvar' }
              </Button>
            </div>
          </>
        }
      </>
    );
  }
}


const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data,
  param: state.param.data
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...UserActions, ...ParamActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InfoEdit);
